import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeLessons: {},
    uiData: {}
}

const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        change(state, action) {
            state.activeLessons = { ...state.activeLessons, [action.payload.studyGroupId]: action.payload.lessonId }
        },
        initUiData(state, action) {
            state.uiData = action.payload
        }
    }
})

export const generalAction = generalSlice.actions;
export default generalSlice;